import { createContext } from 'utils/react-helpers';

const [ClientProvider, useClient] = createContext({ name: 'ClientContext' });

export { ClientProvider, useClient };
